import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { AgenciesService, AgencyConfigDto } from 'src/Services/API';

export const useUpdateAgencyConfig = (
  config?: UseMutationOptions<
    void,
    Error,
    { agencyId: string; brandCode: string; body: AgencyConfigDto },
    unknown
  >
) => {
  return useMutation(async params => {
    return await AgenciesService.agenciesControllerUpdateConfig(params);
  }, config);
};
